import ConsignmentStock from "../../models/ConsignmentStock"
import Granite from "../../models/Granite"
import Organization from "../../models/Organization"
import storage from "../../services/storage"
import { sortBy, flattenTree } from "../../services/utils"

const DEFAULT_FILTERS = {
  contactName: null,
  clientId: null,
  serialNumber: null,
  monument: null,
  granite: null,
  status: null,
  delivered: null,
  placement: null,
  image: null,
  verified: null
}

function filterTree(organizations, clientIds) {
  return organizations.filter(organization => {
    if (organization.isLeaf) {
      return clientIds.includes(organization.client_id)
    } else {
      organization.children = filterTree(organization.children, clientIds)
      return organization.children.length > 0
    }
  })
}

export default {
  data() {
    return {
      visible: false,
      filters: Object.assign({}, DEFAULT_FILTERS),
      organizations: [],
      monuments: [],
      granites: [],
      contactNames: [],
      clientId: null,
    }
  },

  mounted() {
    // apply custom filters, overriding default filters:
    Object.assign(this.filters, storage.fetch("filters:consignment_stocks", {}))

    // get values for filters (list of actual monuments, granites and clients
    // with at least one consignment stock):
    ConsignmentStock.monuments()
      .then(result => this.monuments = sortBy(result, "name"))

    ConsignmentStock.granites()
      .then(result => Granite.all(result))
      .then(result => this.granites = sortBy(result, "name"))

    this.setOrganizationsForContactName()

    ConsignmentStock.contactNames()
      .then(result => this.contactNames = result)

    // apply route filters, overriding custom filters:
    if (this.$route.query.client_id) {
      this.filters.clientId = this.$route.query.client_id
    }
  },

  methods: {
    apply(field) {
      storage.set("filters:consignment_stocks", this.filters)
      this.$emit("applyfilters", this.filters)
      if (field === "contactName") {
        this.setOrganizationsForContactName()
      }
      this.close()
    },

    close() {
      this.visible = false
    },

    setOrganizationsForContactName() {
      Organization.tree().then(tree => {
        return ConsignmentStock
          .clientIds({ contact_name: this.filters.contactName })
          .then(clientIds => filterTree(tree, clientIds))
          .then(result => this.organizations = flattenTree(result))
      })
    },

    filterClient(item, queryText, itemText) {
      if (queryText.match(/^\s*(?:CT-|CA[0-9]+)/i)) {
        itemText = item.client_id
      }
      return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    },

    styleForOrganization(organization) {
      if (organization.client_id.startsWith("CT-")) {
        return "font-weight:bold;"
      }
      if (organization.client_id.endsWith("-SF") || organization.client_id.includes("-SF-")) {
        return "font-weight:bold; padding-left:1em;"
      }
      if (organization.parent_id) {
        return "padding-left:2em;"
      }
      return ""
    }
  },
}
